import * as React from 'react';

function UserIc(props) {
    return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff"
            xmlns="http://www.w3.org/2000/svg" stroke="#2f2f2fff" stroke-width="1.1"
            stroke-linecap="round" stroke-linejoin="round" className='svg-icon' {...props} style={{fill:'none'}}>
            <rect x="4" y="3" width="16" height="18" rx="2.2" />
            <rect x="8" y="2" width="8" height="3" rx="1" fill="#999" stroke="none" />
            <circle cx="12" cy="11" r="2.2" />
            <path d="M7.5 17.2c.9-2.1 2.6-3.2 4.5-3.2s3.6 1.1 4.5 3.2" />
        </svg>

    );
}

export default UserIc;
